import { locale } from '@trqk/utils';

import { HASHES } from '../../../constants';

export const sections: HeaderSection[] = [
    {
        id: HASHES.SETTINGS.PROFILE,
        label: locale.enUS.ACCOUNT.SECTIONS.PROFILE.TITLE,
        name: 'profile',
    },
    {
        id: HASHES.SETTINGS.ENTITY_MANAGER,
        label: locale.enUS.ACCOUNT.SECTIONS.ENTITY_MANAGER.TITLE,
        name: 'entityManager',
    },
    {
        id: HASHES.SETTINGS.INVITE_OTHERS,
        label: locale.enUS.ACCOUNT.SECTIONS.INVITE_OTHERS.TITLE,
        name: 'inviteOthers',
    },
    {
        id: HASHES.SETTINGS.NOTIFICATIONS,
        label: locale.enUS.ACCOUNT.SECTIONS.NOTIFICATIONS.TITLE,
        name: 'notifications',
    },
];

export const sectionsWithPaywall: HeaderSection[] = [
    {
        id: HASHES.SETTINGS.PROFILE,
        label: locale.enUS.ACCOUNT.SECTIONS.PROFILE.TITLE,
        name: 'profile',
    },
    {
        id: HASHES.SETTINGS.ENTITY_MANAGER,
        label: locale.enUS.ACCOUNT.SECTIONS.ENTITY_MANAGER.TITLE,
        name: 'entityManager',
    },
    {
        id: HASHES.SETTINGS.INVITE_OTHERS,
        label: locale.enUS.ACCOUNT.SECTIONS.INVITE_OTHERS.TITLE,
        name: 'inviteOthers',
    },
    {
        id: HASHES.SETTINGS.NOTIFICATIONS,
        label: locale.enUS.ACCOUNT.SECTIONS.NOTIFICATIONS.TITLE,
        name: 'notifications',
    },
    {
        id: HASHES.SETTINGS.PAYMENT_PLAN,
        label: locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN.TITLE,
        name: 'paymentPlan',
    },
];

export const entityManagerTableDimensions = {
    rowHeight: 50,
    tableHeight: 200,
    defaultColumnWidth: 80,
};
